<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="550"
      hide-overlay
      :persistent="true"
      content-class="show-scrollbar dialog-scroll"
    >
      <v-card class="body-1">
        <v-toolbar flat :color="lessonColor">
          <v-toolbar-title>Ответ</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="acceptClosePanel"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md class="pl-4">
          <v-row class="d-flex flex-lg-row flex-xl-row flex-md-row flex-column-reverse">
            <v-col lg="12" md="12" xl="12" sm="12">
              <v-row class="d-flex flex-lg-row flex-xl-row flex-md-row flex-column-reverse">
                <v-col>
                  <span v-if="answer" class="status-row">
                    <p>Статус</p>
                    <p :class="'value-' + answer.status" class="status-value">{{ answerStatus }}</p>
                  </span>
                  <span class="answer-change-buttons">
                    <span>Ваш ответ</span>
                    <span>
                      <v-btn text
                             v-if="canEdit && editMode && allowAnswerAction('create')"
                             @click="saveAnswer()"
                             color="accent">
                        Сохранить
                      </v-btn>
                      <v-btn text
                             v-if="canEdit && !editMode && allowAnswerAction('create')"
                             @click="changeEditMode()"
                             color="accent">
                        Изменить
                      </v-btn>
                      <v-btn text
                             v-if="canEdit && allowAnswerAction('delete')
                             && answer.status === 'draft'"
                             @click="showAcceptDeleteModal()"
                             color="error">
                        Удалить
                      </v-btn>
                    </span>
                  </span>
                  <div>
                    <quill v-model="answer.text"
                           v-bind:class="{ 'ql-read-only': !editMode }"
                           output="html"
                           v-if="dialog && allowAnswerAction('create') && quillReload"
                           :config="quillConfig"
                           @text-change="textOnChange"
                    >
                    </quill>
                  </div>
                  <div v-if="answer && answer.files && answer.files.length"
                       style="margin-top: 15px;">

                    <div class="mb-2" v-if="studentFiles.length">
                      <span> Ваши файлы </span>
                      <p v-for="file of studentFiles"
                         class="file-row body-2 mb-1"
                         :key="file.id">
                          <span>
                            {{ file.original }}
                            <span class="status"
                                  v-if="showFileText(file)">
                                    {{ fileStateText(file) }}
                              <v-btn :small="true" title="Обновить"
                                     @click="updateAnswer(true)"
                                     icon>
                                <v-icon>mdi-refresh</v-icon>
                              </v-btn>
                            </span>
                          </span>
                        <span class="file-buttons">
                            <a :href="file.downloadUrl"
                               v-if="!showFileText(file)"
                               target="_blank" rel="noreferrer">
                              <v-btn :small="true"
                                     icon>
                                <v-icon>mdi-download</v-icon>
                              </v-btn>
                            </a>
                            <v-btn :small="true"
                                   v-if="canEdit && allowAnswerAction('file')"
                                   @click="deleteFile(file.id)"
                                   icon>
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </span>
                      </p>
                    </div>


                    <div class="mb-2" v-if="teacherFiles.length">
                      <span>Файлы преподавателя</span>
                      <p v-for="file of teacherFiles"
                         class="file-row body-2 mb-1"
                         :key="file.id">
                            <span>
                              {{ file.original }}
                              <span class="status"
                                    v-if="showFileText(file)">
                                      {{ fileStateText(file) }}
                                <v-btn :small="true" title="Обновить"
                                       @click="updateAnswer(true)"
                                       icon>
                                  <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                              </span>
                            </span>
                        <span class="file-buttons">
                              <a :href="file.downloadUrl"
                                 v-if="!showFileText(file)"
                                 target="_blank" rel="noreferrer">
                                <v-btn :small="true"
                                       icon>
                                  <v-icon>mdi-download</v-icon>
                                </v-btn>
                              </a>
                            </span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <v-btn text
                           v-if="canEdit && allowAnswerAction('file')"
                           @click="clickOnFile"
                           color="accent">
                      + Файл
                    </v-btn>
                    <input
                      v-if="canEdit && allowAnswerAction('file')"
                      type="file"
                      ref="fileUploader"
                      accept="*"
                      class="d-none"
                      @change="attachFile"
                    />
                  </div>
                  <v-alert type="info"
                           v-if="canEdit && allowAnswerAction('file')"
                           class="body-2 mt-3" dense outlined>
                    Разрешено добавлять файлы объемом не более 50 МБ
                  </v-alert>
                  <div class="d-flex flex-column"
                       v-if="answer && answer.comments && answer.comments.length">

                    <div class="grey lighten-3 d-flex flex-column comment-wrapper"
                         v-if="customComments.length">

                      <v-row justify="space-between" class="flex-wrap mr-0 ml-0 comment-title"
                             align="center">
                        <span>Комментарии</span>

                        <v-btn class="pr-0" v-if="customComments.length > 1 && !expandComments"
                               text @click="expandList()" color="accent">показать еще
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>

                        <v-btn class="pr-0" v-if="customComments.length > 1 && expandComments"
                               text @click="expandList()" color="accent">свернуть
                          <v-icon>mdi-chevron-up</v-icon>
                        </v-btn>
                      </v-row>

                      <div class="d-flex flex-column">
                        <div class="d-flex flex-row comment-row"
                             :key="comment.id"
                             v-for="(comment, idx) of customComments"
                        >

                          <v-row justify="space-between"
                                 class="d-flex flex-row mb-4 mr-0 ml-0"
                                 v-if="idx === 0 || expandComments">
                            <span class="d-flex flex-column">
                               <span class="caption grey--text">
                               <span>{{ getManagerName(comment) }}, </span>
                               <span>{{ getFormattedDate(comment.createdAt) }}</span>
                               </span>
                              <span class="comment-text"
                                    v-bind:class="{'grey--text': checkCommentDate(comment.createdAt, idx)}">
                                  {{ comment.text }}
                              </span>
                            </span>
                            <v-btn
                              icon
                              v-if="isOwnComment(comment) && canEdit
                              && allowAnswerAction('comment')"
                              @click="deleteComment(comment)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-row>
                        </div>
                      </div>
                    </div>

                    <div class="grey lighten-3 d-flex flex-column comment-wrapper"
                         v-if="systemComments.length">
                      <v-row justify="space-between" class="flex-wrap mr-0 ml-0"
                             align="center" :class="getHistoryCss">
                        <span>История</span>
                        <v-btn class="pr-0" @click="expandList('system')" text color="accent"
                               v-if="!expandHistory">показать
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>

                        <v-btn class="pr-0" @click="expandList('system')" color="accent" text
                               v-if="expandHistory">свернуть
                          <v-icon>mdi-chevron-up</v-icon>
                        </v-btn>
                      </v-row>

                      <div v-if="expandHistory" class="d-flex flex-column">
                        <p class="d-flex flex-row comment-row"
                           :key="comment.id"
                           v-for="comment of systemComments"
                        >
                        <span class="d-flex flex-column">
                          <span class="caption grey--text">
                            <span>{{ getManagerName(comment) }}, </span>
                            <span>{{ getFormattedDate(comment.createdAt) }}</span>
                          </span>
                          <span class="comment-text"
                                v-bind:class="{'grey--text': comment.isSystem}">
                            {{ comment.text }}
                          </span>
                        </span>
                          <v-btn
                            icon
                            v-if="isOwnComment(comment) && canEdit && allowAnswerAction('comment')"
                            @click="deleteComment(comment)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </p>
                      </div>
                    </div>
                  </div>
                  <p class="d-flex flex-row add-comment-wrapper"
                     v-if="canEdit && allowAnswerAction('comment')">
                    <v-text-field
                      v-model="newComment"
                      label="Комментарий"
                      hide-details
                      @keydown="handleKeydown($event)"
                    >
                    </v-text-field>
                    <v-btn class="mt-4" text @click="addComment()" color="accent">Добавить</v-btn>
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
          </v-row>
        </v-container>
        <v-card-actions class="align-center">
          <v-spacer></v-spacer>
          <v-btn text @click="acceptClosePanel">Закрыть</v-btn>
          <v-btn text @click="showAcceptSetSendModal" color="rgb(0, 84, 165)"
                 v-if="canEdit && allowAnswerAction('create')">
            Отправить на проверку
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="showNotification"
        :top="true"
        :right="true"
        :timeout="3000"
      >
        {{ notificationText }}
      </v-snackbar>
    </v-dialog>
    <v-dialog v-model="showAcceptModal"
              hide-overlay
              max-width="250"
              persistent
    >
      <v-card>
        <v-container>
          {{ acceptText }}
        </v-container>
        <v-card-actions v-if="showAcceptModal" class="align-center">
          <v-spacer></v-spacer>
          <v-btn text @click="showAcceptModal=false">Нет</v-btn>
          <v-btn text @click="acceptFunction">Да</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { answerStatusMap } from '../../lib/classHelpers';

import Lesson from '../../api/Lesson';


export default {
  name: 'TaskAnswerPopup',
  props: ['answer', 'value', 'lessonColor', 'lesson'],
  data: () => ({
    loading: false,
    newComment: '',
    showAcceptModal: false,
    editMode: false,
    quillReload: true,
    acceptText: '',
    acceptKey: '',
    textWasChanged: false,
    notificationText: '',
    showNotification: false,
    expandHistory: false,
    expandComments: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    getHistoryCss() {
      return this.expandHistory ? 'comment-title' : '';
    },
    answerStatus() {
      if (!this.answer || !answerStatusMap[this.answer.status]) {
        return '';
      }
      return answerStatusMap[this.answer.status].label;
    },
    canEdit() {
      return this.answer && (this.answer.status === 'draft' || this.answer.status === 'return');
    },
    teacherFiles() {
      return this.answer.files.filter(f => f.managerId);
    },
    studentFiles() {
      return this.answer.files.filter(f => !f.managerId);
    },
    systemComments() {
      return this.answer.comments
        .filter(c => c.isSystem)
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    },
    customComments() {
      return this.answer.comments
        .filter(c => !c.isSystem)
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    },
    quillConfig() {
      return {
        placeholder: 'Текст ответа',
        readOnly: !this.editMode,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],

            [{ list: 'ordered' }, { list: 'bullet' }],

            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ font: [] }],
            ['link'],
          ],
        },
      };
    },
    ...mapGetters(['currentUser', 'UISettings']),
  },
  methods: {
    checkCommentDate(date, index) {
      if (this.systemComments.length) {
        const [lastSystemComment] = this.systemComments;
        const commentAfterLast = this.customComments.find(e => moment(e.createdAt) > moment(lastSystemComment.createdAt));

        if (!commentAfterLast) {
          return index !== 0;
        }
        return moment(date) <= moment(lastSystemComment.createdAt);
      }

      return index !== 0;
    },

    expandList(type) {
      if (type === 'system') {
        this.expandHistory = !this.expandHistory;
      } else {
        this.expandComments = !this.expandComments;
      }
    },

    getFormattedDate(date) {
      return moment(date).format('DD.MM.YY HH:mm');
    },

    getManagerName(comment) {
      return comment.managerId ? comment.managerName : this.currentUser.name;
    },

    isOwnComment(comment) {
      return !comment.managerId && !comment.isSystem;
    },

    clickOnFile() {
      this.$refs.fileUploader.click();
    },

    reloadQuillConfig() {
      this.quillReload = false;
      setTimeout(() => { this.quillReload = true; }, 0);
    },

    async acceptFunction() {
      if (this[this.acceptKey]) {
        await this[this.acceptKey]();
      }
    },

    showAcceptSetSendModal() {
      this.acceptKey = 'setSendStatus';
      this.acceptText = 'Вы уверены, что хотите отправить ответ на проверку?';
      this.showAcceptModal = true;
    },

    showAcceptDeleteModal() {
      this.acceptKey = 'deleteAnswer';
      this.acceptText = 'Вы уверены, что хотите удалить ответ?';
      this.showAcceptModal = true;
    },

    textOnChange() {
      this.textWasChanged = true;
    },

    async setSendStatus() {
      try {
        this.showAcceptModal = false;
        this.loading = true;
        if (this.textWasChanged) {
          await this.saveAnswer(true);
        }
        await Lesson.setAnswerSendStatus(this.lesson.id, this.answer.id, {
          userId: this.currentUser.id,
        });
        await this.updateAnswer();
        this.reloadQuillConfig();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    async attachFile(e) {
      const selectedFile = e.target.files[0];
      if (selectedFile && selectedFile.size > 50000000) {
        this.showLargeFileNotification(selectedFile.size);
        return;
      }
      const base64Data = await this.toBase64(selectedFile);
      const data = {
        data: base64Data,
        name: selectedFile.name,
        scopeUserId: this.currentUser.id,
      };
      this.loading = true;
      try {
        await Lesson.uploadAnswerFile(this.lesson.id, this.answer.id, data, () => {});
        this.updateAnswer();
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.status === 413) {
          this.showLargeFileNotification(selectedFile.size);
        } else {
          this.showErrorNotification();
        }
        this.loading = false;
      }
    },

    async deleteComment(comment) {
      await Lesson.deleteAnswerComment(
        this.lesson.id,
        this.answer.id,
        comment.id,
      );
      await this.updateAnswer();
    },

    async deleteFile(fileId) {
      this.loading = true;
      await Lesson.deleteAnswerFile(this.lesson.id, this.answer.id, fileId);
      await this.updateAnswer();
      this.loading = false;
    },

    async handleKeydown(event) {
      if (event.keyCode === 13) {
        await this.addComment();
      }
    },

    async addComment() {
      if (!this.newComment) return;
      const data = {
        text: this.newComment,
        userId: this.currentUser.id,
      };
      await Lesson.addAnswerComment(this.lesson.id, this.answer.id, data);
      await this.updateAnswer();
      this.newComment = '';
    },

    async updateAnswer(files) {
      const answerData = await Lesson.getAnswer(this.lesson.id, this.answer.id, {
        scopeUserId: this.currentUser.id,
      });
      this.$emit(files ? 'update-files' : 'update', answerData.data);
    },

    async saveAnswer(skipUpdate) {
      const data = {
        userId: this.currentUser.id,
        text: this.answer.text,
      };
      await Lesson.saveAnswer(
        this.lesson.id,
        this.answer.id,
        data,
      );
      if (!skipUpdate) {
        await this.updateAnswer();
      }
      this.changeEditMode();
      this.textWasChanged = false;
    },

    async deleteAnswer() {
      this.showAcceptModal = false;
      await Lesson.deleteAnswer(
        this.lesson.id,
        this.answer.id,
      );
      this.$emit('update', { remove: true, id: this.answer.id });
      this.changeEditMode();
      this.dialog = false;
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.toString().replace(/^data:(.*,)?/, ''));
        reader.onerror = error => reject(error);
      });
    },

    allowAnswerAction(action) {
      return !!this.UISettings.answerActions[action];
    },

    showFileText(file) {
      return file.uploadState && file.uploadState !== 'done';
    },

    fileStateText(file) {
      return file.uploadState === 'process' ? 'Обрабатывается' : 'Ошибка загрузки';
    },

    showLargeFileNotification(actualFileSize) {
      this.notificationText = 'Размер файла не должен превышать 50МБ.';
      if (actualFileSize) {
        const fileSizeInMb = Math.floor(actualFileSize / 1e+5) / 10;
        this.notificationText += ` Размер загружаемого файла: ${fileSizeInMb}МБ.`
      }
      this.showNotification = true;
    },

    showErrorNotification() {
      this.notificationText = 'Произошла ошибка';
      this.showNotification = true;
    },

    changeEditMode() {
      this.editMode = !this.editMode;
      this.reloadQuillConfig();
    },

    acceptClosePanel() {
      if (this.textWasChanged) {
        this.acceptText = 'Вы уверены, что хотите закрыть окно? Все несохраненные изменения будут утеряны.';
        this.acceptKey = 'closePanel';
        this.showAcceptModal = true;
      } else {
        this.closePanel();
      }
    },

    closePanel() {
      this.showAcceptModal = false;
      this.textWasChanged = false;
      this.editMode = false;
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="less">
.answer-text {
  line-height: 18px;
  margin-top: 23px;
}

.status-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .status-value {
    width: 30%;
    padding: 0 5px;
    background-color: green;
    text-align: center;
    min-width: 100px;
    &.value-draft {
      background-color: black;
      color: white;
    }

    &.value-sent {
      background-color: rgb(225, 225, 225);
      color: black;
    }

    &.value-accept {
      background-color: rgb(76, 175, 80);
      color: white;
    }

    &.value-return {
      background-color: rgb(251, 139, 0);
      color: white;
    }
  }
}

.comment-wrapper {
  padding: 8px;
  margin-top: 10px;
  .comment-title {
    margin-bottom: 20px;
  }
  .comment-row {
    justify-content: space-between;
    align-items: center;
  }
}

.add-comment-wrapper {
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 0;
}

.status {
  margin-left: 5px;
  color: rgb(137, 137, 137);
  font-size: 12px;
  .v-btn {
    width: 22px;
    height: 22px;
    .v-icon {
      font-size: 16px;
      width: 18px;
    }
  }
}

.answer-change-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
